import { AppSettingsAction, AppSettingsActionType } from './actions';
import { AppSettingsState, initialAppSettingsState } from './AppSettingsState';
import mergeWith from 'lodash/mergeWith';
import cloneDeep from 'lodash/cloneDeep';
import isArray from 'lodash/isArray';
import { Reducer } from 'redux';

export const appSettingsReducer: Reducer<
    AppSettingsState,
    AppSettingsAction
> = (state = initialAppSettingsState, action) => {
    switch (action.type) {
        case AppSettingsActionType.UPDATE: {
            return { ...state, ...action.payload! };
        }
        case AppSettingsActionType.LOAD: {
            return mergeWith(
                cloneDeep(initialAppSettingsState),
                action.payload,
                (defaultVal, loadedVal) =>
                    isArray(defaultVal) ? loadedVal : undefined
            );
        }
    }
    return state;
};
